import { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import Layout from '../UI/introGameLayout/layout';

import IntroLevel1 from './videos/intro-level-1.mp4';
import IntroDebitsCredits from './videos/intro-debits-credits.mp4';

import './styles.css';
import Video from '../UI/introGameLayout/video';

import { gamesQuery, scenarioLevelsQuery } from './api';

import useAuth from '../../auth/useAuth';

export default function BalancedEquationIntro() {
  const navigate = useNavigate();

  const params = useParams();
  const levelNumber = Number(params.levelNumber);

  const [searchParams] = useSearchParams();
  const isOverview = searchParams.has('overview');

  const { getCurrentBalancedEquationGameId, isInstructor } = useAuth();

  const gameId = getCurrentBalancedEquationGameId();

  const [scenarioId, setScenarioId] = useState(0);

  const { data: games } = useQuery(gamesQuery()) || {};

  const { data: scenarioLevels } = useQuery(scenarioLevelsQuery({ scenarioId }));

  useEffect(() => {
    if(games) {
      const game = games.find(game => game.game_type.includes('Balanced Equation') && game.id === gameId);

      if(game && game.scenario) {
        setScenarioId(game.scenario);
      }
    }
  }, [games, gameId]);
  
  const handleContinueButtonClick = () => {
    let redirectUrl;

    if (isOverview) {
      redirectUrl = `${isInstructor() ? '/instructor/settings/' : '/'}assignments`;
    } else {
      redirectUrl = `/balanced-equation/level/${levelNumber}`;
    }

    navigate(redirectUrl);
  }

  const currentScenarioLevel = useMemo(() => {
    if(scenarioLevels) {
      return scenarioLevels.find(level => level.level === levelNumber) || null;
    }
    return null;
  }, [scenarioLevels, levelNumber]);

  const introVideo = currentScenarioLevel?.design?.includes('2') ? IntroDebitsCredits : IntroLevel1;

  return(
    <Layout
      isHeaderVisible={true}
      isContentVertical={true}
      backgroundColor={'#3A507B'}
    >
      <div className="intro-video-wrapper">
        {currentScenarioLevel && <Video videoSrc={introVideo} />}
        {
          (currentScenarioLevel || isOverview) &&
            <button className="intro-button" onClick={handleContinueButtonClick}>Continue</button>
        }
      </div>
    </Layout>
  );
}
